import { render, staticRenderFns } from "./PricingComparison.vue?vue&type=template&id=1b2aec57&scoped=true&"
import script from "./PricingComparison.vue?vue&type=script&setup=true&lang=js&"
export * from "./PricingComparison.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PricingComparison.vue?vue&type=style&index=0&id=1b2aec57&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2aec57",
  null
  
)

export default component.exports